import PageMain from "@/components/page-prompt";
import { useState, useMemo, useEffect } from 'react';
import { Space, Tree, Button, Radio, message, Popconfirm } from 'antd';
import { ADMIN_ROLE, STAFF_MAP, PERMISSIONS, ADMIN_ROLE_EN } from '@bb8/config';
import { useParams, useAccess, history, Access } from 'umi';

import { request } from '@/utils/request';

const Index: React.FC = () => {
  const [expandedKeys, setExpandedKeys] = useState<React.Key[]>(PERMISSIONS.map(item => item.key));
  const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([]);
  const [selectedKeys, setSelectedKeys] = useState<React.Key[]>([]);
  const [autoExpandParent, setAutoExpandParent] = useState<boolean>(true);

  const [canEdit, setCanEdit] = useState<boolean>(true);
  const [role, setRole] = useState<string>(ADMIN_ROLE_EN.PREVIEW_STAFF);

  const [isPrompt, setIsPrompt] = useState<boolean>(true);

  const params: { id: string } = useParams();
  const access = useAccess();

  if (!params.id) {
    return <></>;
  }

  useEffect(() => {
    async function getPermission() {
      const { resp } = await request("/local/wecom/permission", {
        method: "GET",
        params: {
          userid: params.id
        }
      });
      if (resp?.code === 0) {
        const role = resp.data?.role;
        if (role === ADMIN_ROLE_EN.ADMINISTRATOR) setCanEdit(false);
        setRole(role);
        setCheckedKeys(resp.data?.permission);
      }
    }
    getPermission();
  }, [])

  const realPermissions = useMemo(() => {
    const operateTypes = STAFF_MAP[ADMIN_ROLE[role]];

    return PERMISSIONS.map(p => {
      return {
        ...p,
        children: p.children?.filter(c => operateTypes.includes(c?.title as string))
      }
    })
  }, [role]);

  const onExpand = (expandedKeysValue: React.Key[]) => {
    // if not set autoExpandParent to false, if children expanded, parent can not collapse.
    // or, you can remove all expanded children keys.
    setExpandedKeys(expandedKeysValue);
    setAutoExpandParent(false);
  };

  const onCheck = (checkedKeysValue: React.Key[]) => {
    console.log('onCheck', checkedKeysValue);
    setCheckedKeys(checkedKeysValue);
  };

  const onSelect = (selectedKeysValue: React.Key[], info: any) => {
    setSelectedKeys(selectedKeysValue);
  };

  const submit = async () => {
    const { resp } = await request("/local/wecom/permission", {
      method: "POST",
      data: {
        role,
        userid: params.id,
        permission: checkedKeys,
      }
    });
    if (resp?.code !== 0) return
    message.success(resp?.message);
    handleBack();
  }

  const handleBack = () => {
    setIsPrompt(false);
    history.goBack();
  }

  return <PageMain isPrompt={isPrompt}>
    <Space style={{ width: '100%' }} direction="vertical">
      <Space>
        <Button onClick={handleBack}>返回</Button>
        <Access accessible={access.wecomSave && canEdit}>
          <Popconfirm title="确定保存吗？⚠️：若设置该成员角色为管理员，则设置成功之后就没有权限继续配置该成员权限！" onConfirm={submit}>
            <Button type="primary" disabled={!canEdit}>保存</Button>
          </Popconfirm>
        </Access>
      </Space>
      <h3>角色</h3>
      <Radio.Group value={role} disabled={!canEdit} onChange={e => setRole(e.target.value)}>
        {
          Object.keys(ADMIN_ROLE).map(vo => <Radio.Button
            value={vo}
          >
            {ADMIN_ROLE[vo]}
          </Radio.Button>)
        }
      </Radio.Group>

      <h4>说明：管理员拥有所有操作权限。预览人员只能够预览相应的模块内容。运营人员如果想要操作A流程，必须拥有流程模块的可写权限，并且是A流程的创建者或者协作者（可让管理员或者流程创建者进行设置）。</h4>

      {
        role !== ADMIN_ROLE_EN.ADMINISTRATOR && <>
        <h3>权限</h3>
        <Tree
          checkable
          defaultExpandAll={true}
          onExpand={onExpand}
          expandedKeys={expandedKeys}
          autoExpandParent={autoExpandParent}
          onCheck={onCheck}
          checkedKeys={checkedKeys}
          onSelect={onSelect}
          selectedKeys={selectedKeys}
          treeData={realPermissions}
        />
      </>
      }
    </Space>
  </PageMain>
}

export default Index;
